<template>
    <div class="fa-3x"><i class="fa fa-spinner fa-pulse"></i></div>
</template>

<script>
    export default {
        name: "ReportLoad"
    }
</script>

<style scoped>

</style>
